// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3m-Kx","modalFooterButton":"ModalNotes_modalFooterButton__2Ez3b"};